<template>
  <div class="table-task-validations block full">
    <h4>Lista de tareas</h4>    
    <div class="row" v-if="assignmentTypes != null">
      <div class="col-sm-4">
        <label for="">Filtrar por tipo de asignación</label>
      </div>      
      <div class="col-sm-8">
        <select class="form-control select-assignment-types" v-model="filter">
          <option v-for="assignmentType in assignmentTypes" :key="assignmentType.id" :value="assignmentType.id"> {{ assignmentType.name | assignmentTypeName }} </option>
        </select>
      </div>
    </div>
    <div class="feedback-task-validations row" v-if="message != ''">
      <div class="col-sm-12">
        <div class="alert alert-success" role="alert">
          {{message}}
        </div>        
      </div>
    </div>    
    <table class="table">
      <thead>
        <tr>
          <th scope="col">Paso</th>
          <th scope="col">Tipo de asignación</th>
          <th scope="col">Nombre</th>
          <th scope="col">Editar</th>
          <th scope="col">Eliminar</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="taskValidation in filterTaskValidations()" :key="taskValidation.id">
          <th>{{ taskValidation.event_type_name }}</th>
          <td>{{ taskValidation.assignment_type_name }}</td>
          <td>{{ taskValidation.name }}</td>
          <td><button class="btn btn-primary" @click.prevent="changeTaskValidation(taskValidation)">Editar</button></td>
          <td><button class="btn btn-primary" @click.prevent="deleteRecord(taskValidation)">Eliminar</button></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import axios from 'axios';
  import { mapGetters, mapMutations } from 'vuex'
  export default {
    data() {
      return {
        message: '',
        filter: null
      }
    },
    computed: {
      ...mapGetters(['taskValidations', 'assignmentTypes', 'taskValidation'])
    },
    methods: {
      ...mapMutations(['changeTaskValidations', 'changeAssignmentTypes', 'changeTaskValidation']),
      setCredentials (){
        axios.defaults.headers['x-csrf-token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        axios.defaults.headers.common['Accept'] = 'application/json';
        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
      },
      async deleteRecord (taskValidation) {
        this.setCredentials()
        const request = await axios.delete(`/task_validations/${taskValidation.id}`)
        if (request.status == 200) {
          this.message = 'Registro eliminado'
          this.changeTaskValidations(request.data.task_validations)
          setTimeout(() => this.message = '', 3000);
        }
      },
      filterTaskValidations () {
        if (this.filter != null) {
          return this.taskValidations.filter(taskValidation => taskValidation.assignment_type_id == this.filter)
        } else {
          return this.taskValidations
        }        
      },
    },
    watch: {
      filter(newValue, oldValue) {
        if (newValue != oldValue) this.filterTaskValidations()
      }
    },
    filters: {
      assignmentTypeName: function(value) {
        switch (value) {
          case 'academic':
            return 'Académica'
         case 'antecedents':
            return 'Antecedentes'            
          case 'laboral':
            return 'Laboral'
          case 'visit':
            return 'Visita'
          case 'datacredito':
            return 'Datacrédito'
          case 'personal':
            return 'Personal'
          case 'remote_work_visit':
            return 'Visita para teletrabajo'                                                
          default:
            return value
        }
      }
    }    
  }
</script>
